import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationText from './Translations';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationText.en },
      fr: { translation: translationText.fr },
      es: { translation: translationText.es }
    },
    lng: localStorage.getItem("appLanguage") || "en",
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;